import { useState } from "react";
import { enqueueSnackbar } from "notistack";
import { Shield, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../../ui/dialog";
import { Label } from "../../ui/label";
import { Button } from "../../ui/button";
import { MilitarSelectField } from "../../MilitarSelectField";
import { patrulhasService } from "../../../services/patrulhas";
import { useAuth } from "../../../contexts/AuthContext";
import moment from "moment";

interface CriarPatrulhaModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

export function CriarPatrulhaModal({ isOpen, onClose, onSuccess }: CriarPatrulhaModalProps) {
  const [idPatrulheiro, setIdPatrulheiro] = useState("");
  const [loading, setLoading] = useState(false);
  const { militar } = useAuth();

  const handleClose = () => {
    setIdPatrulheiro("");
    onClose();
  };

  const handleSubmit = async () => {
    if (!idPatrulheiro) {
      enqueueSnackbar("Selecione um patrulheiro", { variant: "error" });
      return;
    }

    try {
      setLoading(true);
      await patrulhasService.create({
        id_oficial: militar?.id || "",
        id_patrulheiro: idPatrulheiro,
        inicio: moment().toISOString(),
        status: "EA",
      });

      enqueueSnackbar("Patrulha criada com sucesso!", { variant: "success" });
      handleClose();
      onSuccess?.();
    } catch (error: any) {
      enqueueSnackbar(error.response?.data?.message || "Erro ao criar patrulha", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && handleClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Shield className="h-5 w-5" />
            Criar Patrulha
          </DialogTitle>
          <DialogDescription>
            Selecione o patrulheiro responsável para iniciar uma nova patrulha.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div>
            <Label>Patrulheiro</Label>
            <div className="mt-1">
              <MilitarSelectField
                placeholder="Digite o nick do patrulheiro..."
                onChange={(militarId) => setIdPatrulheiro(militarId)}
              />
            </div>
          </div>

          <div className="flex gap-2 justify-end">
            <Button variant="outline" onClick={handleClose} disabled={loading}>
              Cancelar
            </Button>
            <Button onClick={handleSubmit} disabled={loading || !idPatrulheiro}>
              {loading ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  Criando...
                </>
              ) : (
                "Criar Patrulha"
              )}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
